import { Location } from 'react-router'

export const externalNavigate = (url: string) => {
  window.open(url, '_blank', 'noopener noreferrer')
}

export const navigateWithSearchHash = (location: Location) => {
  return location.pathname + location.search + location.hash
}
